const ISO_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/;
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Hydrates the date strings the API serializes back into `Date` objects,
 * recursively. `DateTime` arrives as ISO-8601 UTC; .NET `DateOnly` arrives as
 * `YYYY-MM-DD` and is anchored to midnight UTC so it does not shift a day in
 * timezones behind Greenwich.
 */
export function convertDates(value: unknown): unknown {
  if (typeof value === 'string') {
    if (ISO_DATE_TIME.test(value)) {
      return new Date(value);
    }

    if (DATE_ONLY.test(value)) {
      return new Date(`${value}T00:00:00Z`);
    }

    return value;
  }

  if (Array.isArray(value)) {
    return value.map(convertDates);
  }

  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [key, convertDates(entry)]),
    );
  }

  return value;
}
